import { type ComponentProps } from "react";
import { spacing, styled } from "../../../../../../../../stitches.config";
import { FlexRow } from "../../../../../../../Common/__styles__/Layout";
import { Body } from "../../../../../../../Common/Typography";
import Label from "../../../../../../../Inputs/Label";

export const WidgetSettingsContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: spacing.m,
});

export const HelpText = (
  props: PartialBy<ComponentProps<typeof Body>, "size" | "type">,
) => (
  <Body
    size="default"
    type="regular"
    color="contentSecondary"
    style={{
      ...props.style,
      marginTop: spacing.xs.value,
      marginInline: 0,
      marginBottom: 0,
    }}
    {...props}
  />
);

export const LabelContainer = styled("div", {
  flexDirection: "row",
  display: "flex",
});

export const LVLabel = styled(Label, {
  marginBottom: spacing.xs,
  flex: "auto",
  float: "left",
});

export const OptionsContainer = styled(FlexRow, {
  paddingTop: spacing.s,
  paddingBottom: spacing.s,
  alignItems: "center",
  gap: spacing.m,
});

export const InputContainer = styled("div", {
  variants: {
    labelOnly: {
      true: {
        flex: "2 1 auto",
      },
    },
  },
});

export const ActionButtonContainer = styled("div", {
  variants: {
    hidden: {
      true: {
        visibility: "hidden",
      },
    },
  },
});
